var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThIconProfileSecurity2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.6485L9.00375 1.4585L16.5 3.6485V8.13933C16.5 10.4409 15.7757 12.684 14.4298 14.5511C13.084 16.4181 11.1848 17.8143 9.00125 18.5418C6.81707 17.8144 4.9172 16.418 3.57088 14.5506C2.22455 12.6831 1.50003 10.4394 1.5 8.13725V3.6485Z",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.37533L8.16667 12.292L13.1667 7.29199",
    stroke: "black",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThIconProfileSecurity2);
export default __webpack_public_path__ + "static/media/TH-Icon-Profile-Security-2.ad150c31649a06fc11c8e8b883a9e657.svg";
export { ForwardRef as ReactComponent };